<div class="login">
  <div class="login-area">
    <div class="login-logo"><img src="assets/img/logo.png"/></div>
    <div class="login-heading">
      @if (!isForgotPasswordFormActive) {
        <h1>Please Login to Continue</h1>
      }
      @if (isForgotPasswordFormActive && !codeSent) {
        <h1>Please enter your email to reset your password</h1>
      }
      @if (isForgotPasswordFormActive && codeSent && !codeVerified) {
        <h1>A token has been sent to your entered email address. Please enter the token below.</h1>
      }
      @if (isForgotPasswordFormActive && codeSent && codeVerified) {
        <h1>Token has been verified. Please enter your new Password below to reset it.</h1>
      }
    </div>
    <div class="errors">
      @for (error of errors | keyvalue; track error) {
        <span>{{ error.value }}</span>
      }
    </div>
    <div class="login-field">
      <form class="example-form" [formGroup]="form" (submit)="login()">
        @if (!codeSent) {
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" placeholder="Email">
              <mat-icon matSuffix>email</mat-icon>
              @if (form.controls.email.invalid) {
                <mat-error>Email invalid</mat-error>
              }
              <!-- <mat-hint>Hint</mat-hint> -->
            </mat-form-field>
          </div>
        }
        @if (codeSent && !codeVerified) {
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>Token</mat-label>
              <input type="number" matInput formControlName="token" placeholder="Enter 6 Digit Token">
              <mat-icon matSuffix>password</mat-icon>
              @if (form.controls.token.invalid) {
                <mat-error>Token invalid</mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (!isForgotPasswordFormActive || codeVerified) {
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" placeholder="Password">
              @if (form.controls.password.invalid) {
                <mat-error>Password invalid</mat-error>
              }
              <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </mat-form-field>
          </div>
        }
        <div class="form-group" style="text-align: left">
          <mat-hint>
            @if (!isForgotPasswordFormActive) {
              <a style="cursor: pointer" (click)="setForgotPasswordForm(true)">Forgot your password?</a>
            }
            @if (isForgotPasswordFormActive && !codeSent) {
              <a style="cursor: pointer" (click)="setForgotPasswordForm(false)">Back to Login</a>
            }
            @if (isForgotPasswordFormActive && codeSent) {
              <a style="cursor: pointer" (click)="setCodeSent(false)">Didn't receive the token? Try again</a>
            }
          </mat-hint>
        </div>

        <button mat-flat-button color="primary">
          @if (!isForgotPasswordFormActive) {
            <span>Login</span>
          }
          @if (isForgotPasswordFormActive && !codeSent) {
            <span>Reset Password</span>
          }
          @if (isForgotPasswordFormActive && codeSent) {
            <span>Verify Token</span>
          }
          @if (loading) {
            <mat-spinner></mat-spinner>
          }
        </button>

      </form>
    </div>
  </div>
</div>

